import React, { useRef, useState } from "react";
import { MdDriveFolderUpload } from "react-icons/md";

function DesktopFileUpload({
  innerText,
  accept,
  selectedFileURL,
  preview,
  defaultPhoto,
  base64,
}) {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(defaultPhoto || null);
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (base64) {
        const fileReader = new FileReader();
        fileReader.onloadend = () => {
          setSelectedFile(fileReader.result);
          selectedFileURL(fileReader.result);
        };
        fileReader.readAsDataURL(file);
      } else {
        selectedFileURL(file);
      }
    }

    // Perform further actions with the selected file
  };
  return (
    <div>
      <button
        className="border flex gap-x-2 items-center rounded-lg border-primary w-full py-2 px-2 whitespace-nowrap text-primary font-medium"
        onClick={handleButtonClick}
        type="button"
      >
        <MdDriveFolderUpload className="text-xl" />
        {innerText}
      </button>
      {preview && (
        <img src={selectedFile} className="h-[20vh] w-full mt-2" alt="" />
      )}
      <input
        type="file"
        ref={fileInputRef}
        accept={accept}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </div>
  );
}

export default DesktopFileUpload;
